import { ContentService, TranslationState } from '@blk/cwp-ng-framework';
import { ScenarioTesterDCR } from '@ddt-web/config';
import { Formatter, InfoBubbleFormatter, NumberFormatter } from '@ddt-web/data-service';
import { BfaConstants } from '@ddt-web/domain';
import * as isNil from 'lodash/isNil';

import { ScenarioAnalysisConfig } from '../constants';

export class ScenarioAnalysisDollarValueFormatter {
	public format(percentageValue: any, aumValue: number, shouldAddValuePrefix: boolean = true): string {
		const formatter = new NumberFormatter(NumberFormatter.NONE, 0);
		let valueToFormat = percentageValue;
		let prefix = '';

		// set prefix if provided percentage value is not nil
		if (!isNil(percentageValue)) {
			if (percentageValue > 0 && shouldAddValuePrefix) {
				prefix = '+ $';
			} else if (percentageValue < 0 && shouldAddValuePrefix) {
				prefix = '- $';
			} else {
				prefix = '$';
			}

			// calculate the amount based on the provided percentageValue and aumValue
			const isPositiveValue = !isNil(percentageValue) && percentageValue > 0;
			percentageValue = isPositiveValue ? percentageValue : percentageValue * -1;

			valueToFormat = percentageValue * aumValue / 100;
		}

		return prefix + formatter.format(valueToFormat);
	}
}

export class ScenarioAnalysisNumberFormatter extends NumberFormatter {
	constructor(public readonly multiplier?: number) {
		super();
	}
	public format(value: any, contentSvc?: ContentService): string {
		const formatter = new NumberFormatter(NumberFormatter.PERCENT, BfaConstants.DEFAULT_DECIMAL_PLACES, NumberFormatter.DASH_VALUE, NumberFormatter.DASH_VALUE, '', this.multiplier);
		const prefix = !isNil(value) && value > 0 ? '+' : '';
		return prefix + formatter.format(value);
	}
}

export class ScenarioAnalysisLabelFormatter implements Formatter {
	public format(value: any, contentSvc?: ContentService): string | TranslationState {
		return contentSvc.resolve(value, ScenarioAnalysisConfig[value]);
	}
}

export class ScenarioTesterCustomFormatter extends InfoBubbleFormatter {
	constructor(public readonly dcrFiller?: string, private scenarioTesterDCR: Object = ScenarioTesterDCR) {
		super(dcrFiller);
	}
	public format(value: any, contentSvc?: ContentService): string | TranslationState {
		const dcrKey = value ? value + '_' + this.dcrFiller : value;
		let codeDefaultValue = value;
		if (this.scenarioTesterDCR.hasOwnProperty(dcrKey)) {
			codeDefaultValue = this.scenarioTesterDCR[dcrKey];
		}
		return contentSvc.resolve(dcrKey, codeDefaultValue);
	}
}
